import CardSliderItem from './CardSliderItem.vue';
import type { Meta, StoryObj } from '@storybook/vue3';
import type { ImageSrcsetItem } from '../../1-atoms/Media/Image/Image.vue';

export const defaultSrcset: ImageSrcsetItem[] = [
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-7196514f.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-a83681a9.webp',
    breakpoint: 390,
    type: 'image/webp',
    width: 390,
    height: 390,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-7bc67de9.jpg',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-da1bf31b.jpg',
    breakpoint: 390,
    type: 'image/jpeg',
    width: 390,
    height: 390,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-a706d850.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-b5387fad.webp',
    breakpoint: 575,
    type: 'image/webp',
    width: 575,
    height: 575,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-41b1583b.jpg',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-28f12a35.jpg',
    breakpoint: 575,
    type: 'image/jpeg',
    width: 575,
    height: 575,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-ac172197.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-f2653798.webp',
    breakpoint: 768,
    type: 'image/webp',
    width: 768,
    height: 415,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-908fcf8a.jpg',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-628820d2.jpg',
    breakpoint: 768,
    type: 'image/jpeg',
    width: 768,
    height: 415,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern_mirrored-e264bf22.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern_mirrored-e264bf22.webp',
    breakpoint: 992,
    type: 'image/webp',
    width: 992,
    height: 518,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern_mirrored-e264bf22.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern_mirrored-e264bf22.webp',
    breakpoint: 992,
    type: 'image/jpeg',
    width: 992,
    height: 518,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern_mirrored-e264bf22.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern_mirrored-e264bf22.webp',
    breakpoint: null,
    type: 'image/webp',
    width: 1200,
    height: 530,
  },
];

const meta = {
  title: 'Molecules/Card Slider Item',
  component: CardSliderItem,
  render: (args, { globals }) => ({
    components: { CardSliderItem },
    setup() {
      return { args, globals };
    },
    template: '<div class="container"><CardSliderItem v-bind="args" /></div>',
  }),
  tags: ['autodocs'],
  argTypes: {
    label: {
      control: { type: 'boolean' },
      description: 'Show/hide the label text',
    },
    labelContent: {
      control: { type: 'text' },
      description: 'Content for the label text shown above the title',
    },
    title: {
      control: { type: 'boolean' },
      description: 'Show/hide the title heading',
    },
    titleContent: {
      control: { type: 'text' },
      description: 'Content for the main title heading',
    },
    button: {
      control: { type: 'boolean' },
      description: 'Show/hide the call-to-action button',
    },
    buttonContent: {
      control: { type: 'text' },
      description: 'Text content for the button',
    },
    buttonUrl: {
      control: { type: 'text' },
      description: 'URL for the button link',
    },
  },
  args: {
    label: true,
    labelContent: 'Freundinnen werben',
    title: true,
    titleContent: 'Sicher dir jetzt 50€ für jede erfolgreiche Ameldung.',
    button: true,
    buttonContent: 'Mehr Informationen',
    buttonUrl: '#',
    image: {
      imageSrcset: defaultSrcset,
    },
  },
} satisfies Meta<typeof CardSliderItem>;

export default meta;
type Story = StoryObj<typeof meta>;

export const Default: Story = {
  args: {
    ...meta.args,
  },
};

export const WithoutLabel: Story = {
  args: {
    ...meta.args,
    label: false,
    titleContent: 'Exklusive Angebote nur für dich',
    buttonContent: 'Jetzt entdecken',
  },
};

export const WithoutButton: Story = {
  args: {
    ...meta.args,
    button: false,
    labelContent: 'Wichtige Information',
    titleContent:
      'Deine nächste Abrechnung wird in den kommenden Tagen verschickt.',
  },
};

export const OnlyTitle: Story = {
  args: {
    ...meta.args,
    label: false,
    button: false,
    titleContent: 'Minimale Kartenansicht nur mit Titel',
  },
};

export const CustomContent: Story = {
  args: {
    ...meta.args,
    labelContent: 'Nachhaltig & Günstig',
    titleContent:
      'Wechsle jetzt zu 100% Ökostrom und spare bis zu 300€ im Jahr.',
    buttonContent: 'Tarif berechnen',
    buttonUrl: 'https://example.com/tariff-calculator',
  },
};

export const ReferralProgram: Story = {
  args: {
    ...meta.args,
    labelContent: 'Freunde werben',
    titleContent:
      'Empfiehl E WIE EINFACH weiter und erhalte 50€ für jede erfolgreiche Anmeldung.',
    buttonContent: 'Mehr erfahren',
    buttonUrl: 'https://example.com/referral',
  },
};

export const ServiceInfo: Story = {
  args: {
    ...meta.args,
    labelContent: 'Kundenservice',
    titleContent:
      'Brauchst du Hilfe? Unser Team ist täglich von 8-20 Uhr für dich da.',
    buttonContent: 'Kontakt aufnehmen',
    buttonUrl: 'tel:+49123456789',
  },
};
